<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
      v-else-if="error.title"
      isDanger
      :title="error.title"
      :body="error.body"
      @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <appointment-form
      v-else
      :initAppointment="initAppointment"
      :initCustomer="initCustomer"
      :initPet="initPet"
      :successMsg="$t('actions.saveChangesSuccess')"
      :submitAction="update"
      :enable-print="true"
  />
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from 'vue'

import { useHTTP } from '@/plugins/http'

import Customer from '@/models/customer/Customer'

// components
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import AppointmentForm from '@/views/appointments/AppointmentForm.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import { useRoute, useRouter } from 'vue-router'
import Appointment from '@/models/customer/Appointment'
import Pet from '@/models/Pet'

export default defineComponent({
  name: 'appointment',
  components: {
    LoadingSpinner,
    AppointmentForm,
    AlertBadge
  },
  setup() {
    const initAppointment = ref(new Appointment())
    const initCustomer = ref(new Customer())
    const initPet = ref(new Pet())
    const error = ref({ title: '', body: '' })
    const http = useHTTP()
    const loading = ref(true)
    const route = useRoute()
    const router = useRouter()

    onBeforeMount(async () => {
      const url = `${Appointment.ENDPOINT}/${route.params.appointment_id}`

      try {
        const resp = await http.get<Appointment>(url)
        initAppointment.value = Appointment.from(resp)
        if (initAppointment.value.customer) {
          initCustomer.value = initAppointment.value.customer
        }
        if (initAppointment.value.pet) {
          initPet.value = initAppointment.value.pet
        }
      } catch (errorResp) {
        error.value.title = errorResp.title
        error.value.body = errorResp.body
      }

      loading.value = false
    })

    const update = async (appointment: Appointment) => {
      try {
        const url = `${Appointment.ENDPOINT}/${appointment.id}`
        appointment.appointmentDate = undefined
        const resp = await http.put<Appointment>(url, appointment)
        initAppointment.value = Appointment.from(resp)
        router.back()
      } catch (error) {
        return error
      }
    }

    return {
      initCustomer,
      initPet,
      initAppointment,
      error,
      loading,
      update
    }
  }
})
</script>
